import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _reject from 'lodash/reject';
import _get from 'lodash/get';
import { EMPTY_ARRAY, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import { getCellOnAction, getMapCellPropsToComponentProps, getColumnId } from '../TableInputField.helpers';
import ActionsList from '../../actionsList';
import TABLE_ACTION_TYPES from '../constants/TableInputField.actionTypes';
import { REMOVE_ACTION } from '../constants/general';
var NO_VISIBLE_ACTION_COUNT = 0;
var VISIBLE_ACTION_COUNT = 1;
var ActionCellRenderer = /*#__PURE__*/function (_Component) {
  _inherits(ActionCellRenderer, _Component);
  var _super = _createSuper(ActionCellRenderer);
  function ActionCellRenderer(props) {
    var _this;
    _classCallCheck(this, ActionCellRenderer);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "getValidActions", function () {
      var _this$props = _this.props,
        original = _this$props.original,
        tdProps = _this$props.tdProps;
      var shouldFilterRemoveFromLastRow = _get(tdProps, 'rest.additional.extra.shouldFilterRemoveFromLastRow') || false;
      var actions = _this.getActions(_this.props);
      if (!(original.isLastRow && shouldFilterRemoveFromLastRow)) return actions;
      return _reject(actions, {
        id: REMOVE_ACTION.id
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleActionClick", function (actionType) {
      var nestingPath = _this.props.nestingPath;
      var onAction = getCellOnAction(_this.props);
      onAction({
        type: TABLE_ACTION_TYPES.TABLE_ACTION_CLICK,
        payload: {
          actionType: actionType,
          nestingPath: nestingPath,
          id: getColumnId(_this.props)
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getVisibleActionCount", function () {
      var actions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_ARRAY;
      var actionsLength = actions.length;
      var showKebabAlways = _this.props.showKebabAlways;
      if (actionsLength > 1) {
        return NO_VISIBLE_ACTION_COUNT;
      }
      if (actionsLength === 1) {
        if (showKebabAlways) return NO_VISIBLE_ACTION_COUNT; // added for cases when we have to show one action in kebab menu
        return VISIBLE_ACTION_COUNT;
      }

      // TODO: Need to handle no action use-case.
      return undefined;
    });
    _this.getActions = getMapCellPropsToComponentProps(props);
    return _this;
  }
  _createClass(ActionCellRenderer, [{
    key: "render",
    value: function render() {
      var actions = this.getValidActions(this.props);
      var visibleActionCount = this.getVisibleActionCount(actions);
      return /*#__PURE__*/React.createElement(ActionsList, {
        actions: actions,
        visibleActionCount: visibleActionCount,
        onActionClick: this.handleActionClick
      });
    }
  }]);
  return ActionCellRenderer;
}(Component);
ActionCellRenderer.propTypes = {
  nestingPath: PropTypes.array,
  original: PropTypes.object,
  tdProps: PropTypes.object,
  showKebabAlways: PropTypes.bool
};
ActionCellRenderer.defaultProps = {
  nestingPath: EMPTY_ARRAY,
  original: EMPTY_OBJECT,
  tdProps: EMPTY_OBJECT,
  showKebabAlways: false
};
export default ActionCellRenderer;